export type { TStateApi as ZustandStoreApi } from 'zustand-x';

export { createZustandStore } from 'zustand-x';
